/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  dusk_10: '#eff1f8',
  dusk_20: '#d8dced',
  dusk_30: '#bdc4de',
  dusk_40: '#99a3c4',
  dusk_50: '#7680a6',
  dusk_60: '#596387',
  dusk_70: '#454e6e',
  dusk_80: '#373f59',
  dusk_90: '#2c3247',
  dusk_100: '#24293b',

  a11y_text_light: [60, 70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/dusk.js